import React from 'react'
import Jumbotron from '../../Components/Jumbotron/Jumbotron'

const About = () => {
   return (
      <div>
         <h1>About Page</h1>
         <Jumbotron />
      </div>
   )
}

export default About
